export const ROLE = {
    ADMIN: 'admin'
}
